import { connect } from 'react-redux';
import get from 'app/common/lib/get';

export default connect(
  (state, { kitId }) => ({
    existingItems: get(state, ['orgs', 'kits', 'items', kitId, 'items'], {}),
  }),
);
